
// export const BASE_URL = "http://127.0.0.1:8000/";
// export const TU_BASE_URL = "http://127.0.0.1:8000/api/";

export const TU_BASE_URL = "https://tu.perigee.com.np/api/";
export const BASE_URL = "https://tu.perigee.com.np/";

// export const TU_BASE_URL = "https://gis.tu.edu.np/api/";
// export const BASE_URL = "https://gis.tu.edu.np/";
